import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export enum FanType {
  PART_COOLING = 1,
  AUXILIARY = 2,
  CHAMBER = 3
}

export class SetFanSpeedCommand extends AbstractCommand {
  public readonly category = 'print';
  public readonly command = 'gcode_line' as const;

  constructor(
    private fanType: FanType,
    private speed: number
  ) {
    super({
      ctrl_type: getFanTypeString(fanType),
      value: speed
    });
  }

  toJSON(): object {
    return {
      print: {
        command: 'gcode_line',
        sequence_id: getSequenceId().toString(),
        gcode: `M106 P${this.fanType} S${this.speed}`
      }
    };
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!('print' in response)) {
      return false;
    }

    const printResponse = response as { print: { sequence_id?: string | undefined } };
    const responseId = printResponse.print?.sequence_id;
    const extraId = this.extra?.sequence_id;

    if (!responseId) {
      return false;
    }

    if (sequence_id && responseId === sequence_id) {
      return true;
    }

    if (extraId && responseId === extraId) {
      return true;
    }

    return false;
  }
}

function getFanTypeString(fanType: FanType): string {
  switch (fanType) {
    case FanType.PART_COOLING:
      return 'part_cooling_fan';
    case FanType.AUXILIARY:
      return 'auxiliary_fan';
    case FanType.CHAMBER:
      return 'chamber_fan';
    default:
      return 'unknown_fan';
  }
}